import { isEmptyObject } from '@sky-it-livedata-libraries/livedata-commons';
import { LgpResultsContainerQuery, LgpResultsContainerSubscription } from '../types';

const isSubscription = (
  container: LgpResultsContainerSubscription | LgpResultsContainerQuery
): container is LgpResultsContainerSubscription =>
  container.data.hasOwnProperty('onUpdateLgpResContainerBySeasonAndCompIdAndGpId');

export const getWidget = (container: LgpResultsContainerSubscription | LgpResultsContainerQuery) =>
  isSubscription(container)
    ? container.data.onUpdateLgpResContainerBySeasonAndCompIdAndGpId
    : container.data.getLgpResultsContainerWidget;

/**
 * typeguard for LGPResultsContainerQuery
 * @param LgpResultsContainer object passed to transformer
 */
export const isValidLgpResultsContainer = (
  LgpResultsContainer: LgpResultsContainerSubscription | LgpResultsContainerQuery
): boolean => (LgpResultsContainer && LgpResultsContainer.data ? Boolean(getWidget(LgpResultsContainer)) && !isEmptyObject(getWidget(LgpResultsContainer)) : false);
